import { render, staticRenderFns } from "./UpdateGraduationYear.vue?vue&type=template&id=49d22696"
import script from "./UpdateGraduationYear.vue?vue&type=script&lang=js"
export * from "./UpdateGraduationYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports